<template>
  <div style="height: 700px">
    <navigation/>
    <div class="main" style="padding-top: 0px;margin-top: 10px;height: 100%">
      <div class="mb-contain">
        <div class="mb-title">我的亮照</div>
        <div class="mb-search clearfix">
          <ul class="mb-cond-list clearfix" id="applyStatus"
              style="background:rgba(0,0,0,0) none repeat scroll !important;">
            <li :class="statusFlag.allStatus ? 'cond-item active' : 'cond-item'"
                @click="search.param.applyStatus = null,statusClick('allStatus')" id="all"
                style="background:rgba(0,0,0,0) none repeat scroll !important;">全部
            </li>
            <li :class="statusFlag.repSuccessStatus ? 'cond-item active' : 'cond-item'"
                @click="search.param.applyStatus = 5,statusClick('repSuccessStatus')" data-status="5"
                style="background:rgba(0,0,0,0) none repeat scroll !important;">复审通过
            </li>
            <li :class="statusFlag.ingStatus ? 'cond-item active' : 'cond-item'"
                @click="search.param.applyStatus = 0,statusClick('ingStatus')" id="ing"
                style="background:rgba(0,0,0,0) none repeat scroll !important;">核对中
            </li>
            <li :class="statusFlag.failStatus ? 'cond-item active' : 'cond-item'"
                @click="search.param.applyStatus = 4,statusClick('failStatus')" id="fail"
                style="background:rgba(0,0,0,0) none repeat scroll !important;">核对失败
            </li>
            <li :class="statusFlag.successStatus ? 'cond-item active' : 'cond-item'"
                @click="search.param.applyStatus = 1,statusClick('successStatus')" id="success"
                style="background:rgba(0,0,0,0) none repeat scroll !important;">亮照核对通过
            </li>
          </ul>
          <div class="mb-find" style="background:rgba(0,0,0,0) none repeat scroll !important;">
            <input type="text" class="search-input" placeholder="输入网站名称/域名快速查询" id="keyWord" v-model="search.like"
                   clearable @change="dataList(1)"/>
            <span class="input-icon" id="keyWordButton" @click="dataList(1)"></span>
          </div>
        </div>

        <div class="mb-table">
          <table class="table" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
              <th>企业名称</th>
              <th>域名</th>
              <th>创建时间</th>
              <th>核对状态</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-bg" v-for="(item,index) in list">
              <td :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">{{ item.companyName }}
              </td>
              <td :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">
                <div class="s-urlManger" :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">
                  <div class="textUrl_hidden_more"
                       :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">
                    {{ item.domainItems[0] }}
                  </div>
                  <span class="s-urlMore" @click="showMore($event);" v-if="item.domainItems.length > 1">
	            	    	  	 					<div class="s-urlContain">
		            	    	  	 					<ul class="s-urlList">
		            	    	  	 						<li class="s-urlItems" v-for="domain in item.domainItems">{{ domain }}</li>
		            	    	  	 					</ul>
	            	    	  	 					</div>
	            	    	  	 				</span>
                </div>
              </td>
              <td :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">{{ item.createTime }}
              </td>
              <td :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">{{ item.applyStatusStr }}

              </td>
              <td :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">
                <router-link :to="{path: '/detailInfo/' + item.siteBaseId}"
                   v-if="item.applyStatus ==0 || item.applyStatus ==3 || item.applyStatus ==4 || item.applyStatus ==6"
                   type="text"
                   style="background:rgba(0,0,0,0) none repeat scroll !important;color: #0da7e6;cursor:pointer">查看详情</router-link>
                <router-link :to="{path: '/detailSite/' + item.siteBaseId}" v-if="item.applyStatus ==1 || item.applyStatus ==5" type="text"
                   style="background:rgba(0,0,0,0) none repeat scroll !important;color: #0da7e6;cursor:pointer">查看亮照</router-link>
                <router-link :to="{path: '/updateSiteBaseInfo/'+ item.siteBaseId}" v-if="item.applyStatus ==2 || item.applyStatus ==4" type="text"
                   style="background:rgba(0,0,0,0) none repeat scroll !important;color: #0da7e6;cursor:pointer">修改信息</router-link>
                <router-link :to="{path:'/changeSite/' + item.siteBaseId}" v-if="item.applyStatus ==1 && item.awaitAdit != 1" type="text"
                   style="background:rgba(0,0,0,0) none repeat scroll !important;color: #0da7e6;cursor:pointer">变更</router-link>
                <router-link :to="{path:'/logoutSite/' + item.siteBaseId}" v-if="item.applyStatus ==1 && item.awaitAdit != 1" type="text"
                   style="background:rgba(0,0,0,0) none repeat scroll !important;color: #0da7e6;cursor:pointer">注销</router-link>
              </td>
            </tr>
            </tbody>
          </table>
          <el-pagination
            style="float: right;"
            background
            layout="prev, pager, next"
            :total="search.page.total"
            :page-count="search.page.pages"
            :page.sync="search.page.current"
            :current-page="search.page.current"
            :page-size.sync="search.page.size"
            @current-change="changePage($event)"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilAPi from '../assets/js/utils'
import navigation from './navigation'

export default {
  name: 'mySitePage',
  components: {
    'navigation': navigation
  },
  data() {
    return {
      statusFlag: {
        allStatus: true,
        repSuccessStatus: false,
        ingStatus: false,
        failStatus: false,
        successStatus: false,
      },
      isLogin: false, // 是否登录
      search: { // 分页查询参数
        param: {
          applyStatus: null,
          companyNumber: null, // 同意社会信用代码
          siteDomain: null, // 网站域名
          companyName: null // 企业名称
        },
        like: null,
        page: {
          total: 0,
          current: 1,
          size: 10
        }
      },
      list: [], // 公示信息列表
      loginInfo: { // 登录接口参数
        userName: null,
        password: null
      }, userInfo: { // 用户信息
        userName: ''
      }
    }
  },
  watch: {
    $route: function (route) {
      this.dataList(this, 1)
    }
  },
  created: function () {
    this.loadMore()
    this.getUserInfo()
  },
  methods: {
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    getUserInfo() {
      let _self = this
      _self.axios.get(
        _self.api.getUserInfo
      ).then(res => {
        if (res.data.code === 10000) {
          this.isLogin = true
          this.userInfo = res.data.obj
        } else {
          this.toIndex()
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 显示多域名预览框
     */
    showMore(event) {
      var elem = $(event.target);
      if (elem.hasClass('s-urlMore') || elem.closest('.s-urlMore').length == 1) {
        if (elem.hasClass('s-urlMore') && elem.find('.s-urlContain').css("display") == "block") {
          $(".s-urlManger .s-urlContain").hide();
        } else {
          elem.find('.s-urlContain').show();
        }
      } else {
        $(".s-urlManger .s-urlContain").hide();
      }
    },
    /**
     * 状态栏切换事件
     */
    statusClick(_self) {
      this.statusFlag.allStatus = false
      this.statusFlag.repSuccessStatus = false
      this.statusFlag.ingStatus = false
      this.statusFlag.failStatus = false
      this.statusFlag.successStatus = false
      this.statusFlag[_self] = true
      this.search.page.current = 1
      this.dataList(1)
    },
    /**
     * 分页点击事件
     */
    changePage(value) {
      this.dataList(value)
    }, loadMore() {
      this.dataList(1)
    },
    /**
     * 列表查询
     */
    dataList(page) {
      this.search.page.current = page
      let _self = this
      _self.axios.post(
        _self.api.queryMyList, this.search,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code === 10000) {
          this.search.page.total = res.data.obj.total
          this.search.page.pages = res.data.obj.pages
          this.list = res.data.obj.records
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
@import '../assets/css/highlight.css';
@import '../assets/css/paging.css';
@import '../assets/css/bright.css';

#applyStatus .li {
  background: rgba(0, 0, 0, 0) none repeat scroll !important;
}

</style>




// WEBPACK FOOTER //
// src/components/mySitePage.vue